export const parrafos = (translatedTexts) => [
  translatedTexts.subtitle_1,
  translatedTexts.subtitle_2,
  translatedTexts.subtitle_3,
];
